<template>
    <div :class="$style['token-dialog']">
        <div :class="$style['token-dialog__menu-container']">
            <mds-popover
                v-model="toggleMenu"
                triggered-by="token-dialog-user-button"
                :position="['bottom-left']"
                :class="$style['token-dialog__popover']"
                width="200px">
                <!-- Icon On Left -->
                <mds-button variation="primary" type="button" :class="$style['region-button']" @click="toggleRegion=!toggleRegion" action-required> 
                    <span aria-hidden="true" class="mds-icon___devsite mds-icon--small___devsite mds-button__icon___devsite">
                        <svg width="20" height="20" viewBox="0 0 49 48" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.5 45C36.098 45 45.5 35.598 45.5 24C45.5 12.402 36.098 3 24.5 3C12.902 3 3.5 12.402 3.5 24C3.5 35.598 12.902 45 24.5 45Z" fill="none" stroke-miterlimit="10"/>
                            <path d="M12.23 7H27.5L28.5 8H38.1055" fill="none" stroke-miterlimit="10"/>
                            <path d="M5.625 15H7.5L10.5 18H4.5" fill="none" stroke-miterlimit="10"/>
                            <path d="M38.5 17L33.33 22.17C32.29 23.21 33.03 25 34.5 25L38.5 21V17Z" fill="none" stroke-miterlimit="10"/>
                            <path d="M19.5 37L22.5 34H27.5L29.5 36V40L28.91 40.59C28.13 41.37 26.86 41.37 26.08 40.59L25.49 40H19.49L19.5 37Z" fill="none" stroke-miterlimit="10"/>
                            <path d="M32.5 37L33.5 36H37.5L34.5 39L32.5 37Z" fill="none" stroke-miterlimit="10"/>
                            <path d="M40.3281 10.1992L35.5 15.0001H32.5L29.5 18.0001V22.0001L27.5 24.0001V28.0001L25.68 29.8201C24.88 30.6201 23.5 30.0501 23.5 28.9201V27.0001L20.5 24.0001L17.5 27.0001L12.5 22.0001L9.50001 25.0001L12.5 28.0001V34.0001L8.70001 37.8001" fill="none" stroke-miterlimit="10"/>
                        </svg>
                    </span>
                    {{ getSelectedRegionText() }} 
                </mds-button>
                <mds-button variation="primary" text="Contact Us" :class="$style['dark-button']"
                    href="https://www.morningstar.com/business/products/direct-web-services/contact"
                    target="_blank"></mds-button>
            </mds-popover>
        </div>

        <div :class="$style['token-dialog__button-container']">
            <!-- Icon On Left -->
            <mds-button variation="primary" type="button" :class="$style['region-button']" @click="toggleRegion=!toggleRegion" action-required> 
                <span aria-hidden="true" class="mds-icon___devsite mds-icon--small___devsite mds-button__icon___devsite">
                    <svg width="20" height="20" viewBox="0 0 49 48" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.5 45C36.098 45 45.5 35.598 45.5 24C45.5 12.402 36.098 3 24.5 3C12.902 3 3.5 12.402 3.5 24C3.5 35.598 12.902 45 24.5 45Z" fill="none" stroke-miterlimit="10"/>
                        <path d="M12.23 7H27.5L28.5 8H38.1055" fill="none" stroke-miterlimit="10"/>
                        <path d="M5.625 15H7.5L10.5 18H4.5" fill="none" stroke-miterlimit="10"/>
                        <path d="M38.5 17L33.33 22.17C32.29 23.21 33.03 25 34.5 25L38.5 21V17Z" fill="none" stroke-miterlimit="10"/>
                        <path d="M19.5 37L22.5 34H27.5L29.5 36V40L28.91 40.59C28.13 41.37 26.86 41.37 26.08 40.59L25.49 40H19.49L19.5 37Z" fill="none" stroke-miterlimit="10"/>
                        <path d="M32.5 37L33.5 36H37.5L34.5 39L32.5 37Z" fill="none" stroke-miterlimit="10"/>
                        <path d="M40.3281 10.1992L35.5 15.0001H32.5L29.5 18.0001V22.0001L27.5 24.0001V28.0001L25.68 29.8201C24.88 30.6201 23.5 30.0501 23.5 28.9201V27.0001L20.5 24.0001L17.5 27.0001L12.5 22.0001L9.50001 25.0001L12.5 28.0001V34.0001L8.70001 37.8001" fill="none" stroke-miterlimit="10"/>
                    </svg>
                </span>
                {{ getSelectedRegionText() }} 
            </mds-button>
            <mds-button variation="primary" text="Contact Us" :class="$style['dark-button']"
                href="https://www.morningstar.com/business/products/direct-web-services/contact"
                target="_blank"></mds-button>
        </div>


        <mds-modal size="small" width="600px" aria-label="Region Modal" v-model="toggleRegion" aria-labelledby="region-modal-title" action-required>
            <mds-section class="with-nested-sections" border-position="bottom" bold>
                <template #mds-section-title>
                    <span id="region-modal-title">Select Region</span>
                </template>
                <template #mds-section-actions>
                    <mds-button-container right-aligned>
                        <mds-button v-if="hasRegionCookie" @click="toggleRegion = !toggleRegion" variation="secondary">Cancel</mds-button>
                        <mds-button :disabled="!selectedRegion" @click="applyRegionChanges()" variation="primary">Apply</mds-button>
                    </mds-button-container>
                </template>
                
                <mds-section :class="$style['region-modal-body']" border="none" bold :size="6">
                    <p>Select your region to view documentation for the services available.</p>
                    <mds-form>
                        <mds-fieldset
                            variation="radio-group"
                        >
                            <mds-radio-button
                                name="regionGroup"
                                value="na"
                                v-model="selectedRegion"
                            >Americas</mds-radio-button>
                            <mds-radio-button
                                name="regionGroup"
                                value="emea"
                                v-model="selectedRegion"
                            >APAC/EMEA</mds-radio-button>
                        </mds-fieldset>
                        
                        <mds-checkbox value="accept" checked disabled>Remember my choice on this device</mds-checkbox>
                    </mds-form>
                </mds-section>
            </mds-section>
        </mds-modal>

    </div>
</template>

<script>

import { MdsButton, MdsButtonContainer } from '@mds/button';
import MdsModal from '@mds/modal';
import MdsPopover from '@mds/popover';
import MdsSection from '@mds/section';
import MdsForm from '@mds/form';
import MdsFieldset from '@mds/fieldset';
import MdsRadioButton from '@mds/radio-button';
import MdsCheckbox from '@mds/checkbox';
import { ENABLE_USER_MANAGEMENT } from '../data/constants';
import { getCookie, setCookie, hasCookie } from '../utils/cookieService.js';

const regionAbbrMapping = {
    emea: 'APAC/EMEA',
    na: 'Americas',
};

export default {
name: 'token-dialog',
    components: {
        MdsButton,
        MdsButtonContainer,
        MdsModal,
        MdsPopover,
        MdsSection,
        MdsForm,
        MdsFieldset,
        MdsRadioButton,
        MdsCheckbox,
    },
    data() {
        return {
            toggleRegion: false,
            toggle: false,
            tokenString: '',
            auth0IsAuthenticated: false,
            toggleMenu: false,
            ENABLE_USER_MANAGEMENT: ENABLE_USER_MANAGEMENT,
            hasRegionCookie: false,
            selectedRegion: '',
        };
    },
    created() {

        // Check region cookie first (highest priority)
        this.hasRegionCookie = hasCookie('region');

        if(!this.hasRegionCookie) {
            this.toggleRegion = true; // Show region modal if no region cookie
        } else {
            this.selectedRegion = getCookie('region');
        }

        // Listen for region modal toggle events
        this.$eventBus.$on('regionModal:toggle', this.handleRegionModalToggle);
    },
    beforeDestroy() {
        // Remove event listeners to prevent memory leaks
        this.$eventBus.$off('regionModal:toggle', this.handleRegionModalToggle);
    },
    computed: {
    },
    methods: {
        getSelectedRegionText() {
            const region = getCookie('region');
            return regionAbbrMapping[region] || "Select Region";
        },
        applyRegionChanges() {
            setCookie('region', this.selectedRegion, { days: 365 }); // 365 days = 1 year
            this.toggleRegion = false;
            
            // Emit event to notify other components about the region change
            this.$eventBus.$emit('region:changed', { region: this.selectedRegion });
        },

        // EventBus handlers for region modal
        handleRegionModalToggle() {
            this.toggleRegion = !this.toggleRegion;
        },
    },
}
</script>
<style module lang="scss">
    @import '../style/components/token-dialog';
</style>